import { isEqual, isEmpty } from 'lodash'
import { useEffect } from 'react'
import { connect } from 'react-redux'
import { Input, Col, Row, Label, FormGroup } from 'reactstrap'
import AddressList from './AddressList'
import { setCustomerAddress, setBillingAddress, setUseShippingAsBilling } from './checkoutFunctions'

const CheckoutAddressPanel = ({
  addressType,
  addresses,
  useShippingAsBilling,
  setUseShippingAsBilling,
  allItemsDigital,
  ...props
}) => {
  const customerAddressPresent = !isEmpty(props.selectedCustomerAddress)
  const billingAddressPresent = !isEmpty(props.selectedBillingAddress)
  const addressesAreEqual = isEqual(props.selectedBillingAddress, props.selectedCustomerAddress)
  const bothAddressesPresent = customerAddressPresent && billingAddressPresent
  const addressesEqualAndPresent = bothAddressesPresent && addressesAreEqual

  const handleSelectAddress = (address, deselect = false) => {
    if (addressType === 'delivery') {
      props.setCustomerAddress(deselect ? {} : address).then(() => {
        // additionally set billing if same address checkbox is checked
        if (useShippingAsBilling) {
          props.setBillingAddress(address)
        }
      })
    } else if (addressType === 'billing') {
      props.setBillingAddress(deselect ? {} : address)
    }
  }

  // If only one address, set as selected (only for shipping)
  useEffect(() => {
    if (addresses.length === 1 && addressType === 'delivery') {
      handleSelectAddress(addresses[0])
    }
  }, [])

  // un-check use shipping as billing under certain conditions
  useEffect(() => {
    if (
      (props.manageAddresses === true && useShippingAsBilling === true) ||
      (props.newAddressMode === true && useShippingAsBilling === true)
    ) {
      if (addressType === 'delivery') {
        setUseShippingAsBilling(false)
      }
    }
  }, [props.newAddressMode, props.manageAddresses])

  const onUseShippingAsBillingChange = isChecked => {
    setUseShippingAsBilling(isChecked)
  }

  const handleClickUseAsBilling = e => {
    const incomingValue = e.target.checked
    onUseShippingAsBillingChange(incomingValue)

    if (incomingValue === false) {
      props.setBillingAddress({})
      return
    }

    if (incomingValue === true && customerAddressPresent && !addressesAreEqual) {
      props.setBillingAddress(props.selectedCustomerAddress)
    }
  }

  const showUseAsBillingCheckbox =
    addressType === 'delivery' && (props.youPay > 0 || (props.youPay === 0 && props.requireBillingAddressForFreeOrders))

  return (
    <>
      <Row>
        <Col xs="12" style={{ paddingBottom: '0px' }}>
          <AddressList
            addresses={addresses}
            addressType={addressType}
            handleSelectAddress={handleSelectAddress}
            selectedAddress={addressType === 'billing' ? props.selectedBillingAddress : props.selectedCustomerAddress}
            useShippingAsBilling={useShippingAsBilling}
            allItemsAreDigital={allItemsDigital}
          />
        </Col>
      </Row>

      {showUseAsBillingCheckbox ? (
        <FormGroup check className="float-right w-100 pb-3 pl-0 pr-3">
          <Label check className="float-right">
            <Input
              type="checkbox"
              onChange={handleClickUseAsBilling}
              checked={useShippingAsBilling || addressesEqualAndPresent}
            />
            Use as billing address
          </Label>
        </FormGroup>
      ) : null}
    </>
  )
}

const mapStateToProps = state => {
  return {
    requireBillingAddressForFreeOrders: state.currentLocation.require_billing_address_for_free_orders,
    selectedDeliveryAddress: state.checkout.selectedDeliveryAddress,
    managed_customer_addresses: state.managed_customer_addresses,
    customer_addresses: state.customer_addresses,
    selectedCustomerAddress: state.checkout.selectedCustomerAddress,
    selectedBillingAddress: state.checkout.selectedBillingAddress,
    youPay: state.checkout.youPay,
    portal: state.portal,
    useShippingAsBilling: state.checkout.useShippingAsBilling
  }
}

export default connect(mapStateToProps, {
  setCustomerAddress,
  setBillingAddress,
  setUseShippingAsBilling
})(CheckoutAddressPanel)
